module.exports = "/images/pay-now-cards.png?f7c642f9db5e43c5dfe6f568bfc51361";